// components/EntityStatistics.tsx
import React, { useState } from "react";
import { Card, Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ENTITY_BORDER_COLORS } from "../utils/constant";
import { EntityType } from "../utils/types";

interface EntityStatisticsProps {
  annotations: any[];
  currentPageAnnotations: any[];
  entityTypes: string[];
}

const EntityStatistics: React.FC<EntityStatisticsProps> = ({
  annotations,
  currentPageAnnotations,
  entityTypes,
}) => {
  const [showStats, setShowStats] = useState(false);

  // Count annotations by entity type
  const annotationCounts = entityTypes.reduce((acc, type) => {
    acc[type] = annotations.filter((anno) => anno.entity === type).length;
    return acc;
  }, {} as Record<string, number>);

  return (
    <div>
      <h6 className="d-flex justify-content-between align-items-center mb-3">
        <span>Statistics</span>
        <Button
          variant="link"
          className="p-0 text-decoration-none"
          onClick={() => setShowStats(!showStats)}
          size="sm"
        >
          {showStats ? "Hide" : "Show"}
        </Button>
      </h6>

      {showStats && (
        <div className="mb-3">
          <Card className="bg-light border-0">
            <Card.Body className="py-2 px-3">
              <div className="d-flex justify-content-between mb-2">
                <small className="text-muted">Total Annotations:</small>
                <Badge bg="primary">{annotations.length}</Badge>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <small className="text-muted">Current Page:</small>
                <Badge bg="info">{currentPageAnnotations.length}</Badge>
              </div>
              <hr className="my-2" />
              {entityTypes.map((type) => (
                <div key={type} className="d-flex justify-content-between mb-1">
                  <OverlayTrigger
                    placement="left"
                    overlay={<Tooltip>{type}</Tooltip>}
                  >
                    <small
                      className="text-muted text-truncate"
                      style={{ maxWidth: "70%" }}
                    >
                      {type}:
                    </small>
                  </OverlayTrigger>
                  <Badge
                    bg="secondary"
                    style={{
                      backgroundColor: ENTITY_BORDER_COLORS[type as EntityType],
                      color:
                        type === "SPECIES" || type === "CHEMICAL"
                          ? "black"
                          : "white",
                    }}
                  >
                    {annotationCounts[type] || 0}
                  </Badge>
                </div>
              ))}
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
};

export default EntityStatistics;
